export function asSliceSelectors(collection) {
    return collection;
}
export function asSliceActions(collection) {
    return collection;
}
